/*!
 * szb-google-rating.js – Szerelvénybolt Kft.
 *
 * Google értékelés badge Shopify storefronton.
 * Oldalbetöltés után lekéri a JSON-t, és kirajzol egy Google-jellegű badge-et:
 * pontszám + arányosan kitöltött csillagok (1-5) + véleményszám.
 *
 * TELEPÍTÉS (Shopify):
 *  1) Online Store > Themes > Edit code > Assets > Add a new asset:
 *     töltsd fel ezt a fájlt "szb-google-rating.js" néven.
 *  2) A theme.liquid-ban, a </body> elé:
 *     <script src="{{ 'szb-google-rating.js' | asset_url }}" defer></script>
 *  3) Ahol meg kell jelennie (bármelyik section/snippet/liquid template):
 *     <div data-szb-google-rating></div>
 *
 * Opciók data-attribútumként:
 *     <div data-szb-google-rating
 *          data-size="lg"                 sm | md (alap) | lg
 *          data-layout="inline"           inline (alap) | card
 *          data-label="Google-vélemény"   a szám utáni szöveg
 *          data-show-count="true"
 *          data-link="true"               kattintható-e
 *          data-bust="hour"               hour (alap) | day | none – cache-buster
 *          data-endpoint="https://...">   saját JSON URL
 *     </div>
 *
 * FIGYELEM: a JSON más domainen van (feed.szerelvenybolt.hu), mint a Shopify
 * storefront, ezért a válasznak Access-Control-Allow-Origin fejlécet kell
 * küldenie – lásd a mellékelt .htaccess mintát.
 *
 * Programozottan:  SzbGoogleRating.render(el, {size:'lg'});  SzbGoogleRating.refresh();
 */

(function () {
  'use strict';

  var DEFAULTS = {
    // A rating.php ugyanazt a JSON-t adja vissza, mint a rating.json, csak
    // CORS fejléccel – a statikus .json-hoz az Apache nem teszi rá.
    // Ha egyszer a .htaccess/mod_headers rendben lesz, ide írhatod a
    // .../shopifyB2C/rating.json URL-t.
    endpoint: 'https://feed.szerelvenybolt.hu/shopifyB2C/rating.php',
    reviewsUrl: 'https://www.google.com/storepages?q=szerelvenybolt.hu&c=HU&hl=hu',
    label: 'Google-vélemény',
    size: 'md',
    layout: 'inline',
    showCount: true,
    link: true,
    cacheMinutes: 30,
    // Statikus JSON-t a böngésző/CDN sokáig cache-elhet, ezért óránként
    // változó query paramétert fűzünk hozzá: 'hour' | 'day' | 'none'
    bust: 'hour',
    timeoutMs: 6000
  };

  var CACHE_KEY = 'szb_gr_cache_v1';
  var STYLE_ID = 'szb-gr-style';
  var SELECTOR = '[data-szb-google-rating]';
  var fetchPromises = {}; // endpointonként külön

  // --- stílus (egyszer kerül be) -------------------------------------------

  var CSS = [
    '.szb-gr{display:inline-flex;align-items:center;gap:.5em;font-family:inherit;',
    'line-height:1.2;color:inherit;text-decoration:none;white-space:nowrap}',
    '.szb-gr--card{padding:.6em .9em;border:1px solid rgba(0,0,0,.12);border-radius:10px;',
    'background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.06)}',
    '.szb-gr--sm{font-size:13px}.szb-gr--md{font-size:15px}.szb-gr--lg{font-size:18px}',
    '.szb-gr__score{font-weight:700;font-size:1.15em}',
    '.szb-gr__stars{position:relative;display:inline-block;flex:0 0 auto;line-height:0}',
    // max-width:none kell, mert sok Shopify téma globálisan svg{max-width:100%}-ot ad
    '.szb-gr__stars svg{display:block;height:1.15em;width:auto;max-width:none;min-width:0}',
    '.szb-gr__stars-fill{position:absolute;top:0;left:0;overflow:hidden;line-height:0}',
    '.szb-gr__count{color:#5f6368;font-size:.95em}',
    'a.szb-gr:hover .szb-gr__count{text-decoration:underline}',
    '@media (prefers-color-scheme:dark){.szb-gr__count{color:#9aa0a6}}'
  ].join('');

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  // --- csillagok ------------------------------------------------------------

  var STAR_PATH = 'M10 1.6l2.58 5.23 5.77.84-4.17 4.07.98 5.75L10 14.77l-5.16 2.72.98-5.75'
                + 'L1.65 7.67l5.77-.84z';

  function starsSvg(color) {
    var parts = ['<svg viewBox="0 0 100 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'];
    for (var i = 0; i < 5; i++) {
      parts.push('<path transform="translate(' + (i * 20) + ' 0)" d="' + STAR_PATH + '" fill="' + color + '"/>');
    }
    parts.push('</svg>');
    return parts.join('');
  }

  /**
   * Két csillagsor egymáson: alul szürke, felül arany, a felső a pontszám
   * arányában levágva -> pontos, tört értékű kitöltés (pl. 4,8 => 96%).
   */
  function buildStars(rating) {
    var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    var wrap = document.createElement('span');
    wrap.className = 'szb-gr__stars';
    wrap.innerHTML = starsSvg('#dadce0')
      + '<span class="szb-gr__stars-fill" style="width:' + pct.toFixed(2) + '%">'
      + starsSvg('#fbbc04') + '</span>';

    // A felső (arany) sor teljes szélességben rajzolódik, a szülő vágja le
    // a megfelelő százaléknál – így nem zsugorodik, hanem valóban levágódik.
    return wrap;
  }

  // --- adatlekérés ----------------------------------------------------------

  function cacheKeyFor(endpoint) {
    return CACHE_KEY + ':' + endpoint;
  }

  function readCache(endpoint, minutes) {
    if (!minutes) return null;
    try {
      var raw = window.sessionStorage.getItem(cacheKeyFor(endpoint));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.data) return null;
      if (Date.now() - obj.t > minutes * 60000) return null;
      return obj.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(endpoint, data) {
    try {
      window.sessionStorage.setItem(cacheKeyFor(endpoint), JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) { /* privát mód / tele van – nem gond */ }
  }

  /**
   * Cache-buster: óránként (vagy naponta) változó ?v= paraméter, hogy a
   * statikus rating.json ne ragadjon be a böngésző/CDN cache-ébe.
   */
  function bustUrl(url, mode) {
    if (mode === 'none') return url;
    var d = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var v = '' + d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate());
    if (mode !== 'day') v += pad(d.getUTCHours());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'v=' + v;
  }

  function fetchData(opts) {
    var key = opts.endpoint;
    if (fetchPromises[key]) return fetchPromises[key];

    var cached = readCache(key, opts.cacheMinutes);
    if (cached) {
      fetchPromises[key] = Promise.resolve(cached);
      return fetchPromises[key];
    }

    fetchPromises[key] = new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () {
        if (!done) { done = true; reject(new Error('timeout')); }
      }, opts.timeoutMs);

      fetch(bustUrl(opts.endpoint, opts.bust), { credentials: 'omit', cache: 'default' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          if (!data || typeof data.rating === 'undefined') throw new Error('rossz JSON');
          writeCache(key, data);
          resolve(data);
        })
        .catch(function (err) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          reject(err);
        });
    });

    return fetchPromises[key];
  }

  // --- kirajzolás -----------------------------------------------------------

  function optsFrom(el) {
    var d = el.dataset || {};
    return {
      endpoint: d.endpoint || DEFAULTS.endpoint,
      reviewsUrl: d.reviewsUrl || DEFAULTS.reviewsUrl,
      label: typeof d.label === 'string' && d.label !== '' ? d.label : DEFAULTS.label,
      size: d.size || DEFAULTS.size,
      layout: d.layout || DEFAULTS.layout,
      showCount: d.showCount !== 'false',
      link: d.link !== 'false',
      cacheMinutes: d.cacheMinutes ? parseInt(d.cacheMinutes, 10) : DEFAULTS.cacheMinutes,
      bust: d.bust || DEFAULTS.bust,
      timeoutMs: DEFAULTS.timeoutMs
    };
  }

  function paint(el, data, opts) {
    var rating = parseFloat(data.rating);
    console.log(rating);
    if (!isFinite(rating) || rating <= 0) { el.style.display = 'none'; return; }

    var ratingText = data.rating_formatted || String(rating).replace('.', ',');
    var countText = data.count_formatted || (data.count != null ? String(data.count) : '');

    var root = document.createElement(opts.link ? 'a' : 'div');
    root.className = 'szb-gr szb-gr--' + opts.size
      + (opts.layout === 'card' ? ' szb-gr--card' : '');

    if (opts.link) {
      root.href = opts.reviewsUrl;
      root.target = '_blank';
      root.rel = 'noopener nofollow';
    }
    root.setAttribute('aria-label',
      'Google értékelés: ' + ratingText + ' az 5-ből'
      + (countText ? ', ' + countText + ' vélemény alapján' : ''));

    var score = document.createElement('span');
    score.className = 'szb-gr__score';
    score.textContent = ratingText;
    root.appendChild(score);

    root.appendChild(buildStars(rating));

    if (opts.showCount && countText) {
      var count = document.createElement('span');
      count.className = 'szb-gr__count';
      count.textContent = countText + (opts.label ? ' ' + opts.label : '');
      root.appendChild(count);
    }

    el.textContent = '';
    el.appendChild(root);
    el.style.display = '';
    el.setAttribute('data-szb-rendered', '1');
  }

  function render(el, override) {
    if (!el) return;
    var opts = optsFrom(el);
    if (override) { for (var k in override) { if (override.hasOwnProperty(k)) opts[k] = override[k]; } }

    injectStyle();

    fetchData(opts).then(function (data) {
      paint(el, data, opts);
    }).catch(function (err) {
      // Nincs adat -> nem jelenítünk meg semmit, és nem is hibázunk láthatóan.
      el.style.display = 'none';
      el.setAttribute('data-szb-rendered', 'error');

      // Fejlesztői segítség: a leggyakoribb ok a hiányzó CORS fejléc.
      if (window.console && console.warn) {
        console.warn('[szb-google-rating] Nem sikerült a lekérés: ' + (err && err.message)
          + '. Ha "Failed to fetch" / CORS hibát látsz a konzolon, a '
          + opts.endpoint + ' válaszához hiányzik az '
          + 'Access-Control-Allow-Origin fejléc (lásd a .htaccess mintát).');
      }
    });
  }

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-szb-rendered')) continue;
      render(nodes[i]);
    }
  }

  function refresh() {
    try {
      for (var i = window.sessionStorage.length - 1; i >= 0; i--) {
        var k = window.sessionStorage.key(i);
        if (k && k.indexOf(CACHE_KEY) === 0) window.sessionStorage.removeItem(k);
      }
    } catch (e) { /* noop */ }
    fetchPromises = {};
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) { nodes[i].removeAttribute('data-szb-rendered'); }
    scan(document);
  }

  // --- indítás --------------------------------------------------------------

  function boot() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor / section újratöltés
  document.addEventListener('shopify:section:load', function (e) {
    scan(e && e.target ? e.target : document);
  });

  window.SzbGoogleRating = { render: render, scan: scan, refresh: refresh, defaults: DEFAULTS };
})();